import type { FaireProductEntity } from "../../entity_types/product";

export const p_a4s4mpspn5: FaireProductEntity = {
  token: "p_a4s4mpspn5",
  type: "product",
  name: "Uplifting Uganda 100% Cacao - Organic Ceremonial Chocolate",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/a9d88dddb626c7e42345c1edf456ddd22791133cb329ef989c3ac43296ccdcdd.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fac8d767d9ee64fbcd8f65d25cf1a6227a9165431f0d156322be6016a2e21ef0.png",
    "https://cdn.faire.com/fastly/1f747abb235ee5e0715737b342f0dbf39252528a60e39453e42c7a02edc40e90.png",
    "https://cdn.faire.com/fastly/064b94bd5eebe080422e6cf3161eab913ac1ddb843f17e65b665820a859e8621.png",
    "https://cdn.faire.com/fastly/8fbc2d8e7beb8c4e25e9340927556278231d6a4e410a1aa1e465bbf5c574056b.png",
    "https://cdn.faire.com/fastly/3f41eb888efb6b5651a95d5a7d96ca4e232d54231e09d8fee52e5614815df1fd.png",
    "https://cdn.faire.com/fastly/fade583a3c77a34cae51702eadc334eb60632a2e59d2366da6454a9dc37f4040.png",
  ],
  priceDollars: 16.8,
  description:
    "Let this cacao fill you with joy! Its generous spirit carries the heartbeat of the Semuliki Forest - a lush, tropical rainforest beneath the soaring Rwenzori mountains that form the border between the Congo and Uganda, and are also part of the Nile River headwaters.\n\nThis cacao is grown by over 50% female farmers who imbue this cacao with their strength & spirit. 70% of the farmers are under the age of 35, so this cacao contributes good livelihood to a vibrant young generation of farmers.\n\nWork with this cacao to experience strengthening in your soul and your power. It feels like a steady drumbeat under the mountain. Enjoy consistent and classic chocolate flavor notes reminding us of a childhood hot cocoa, chocolate fudge and chocolate truffles.\n\n• Makes a great coffee replacement!\n• For dark chocolate lovers.\n• Lab tested for heavy metals safety.\n• High flavanol / flavonoid.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:42.202Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
